/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "releasemanager": {
                            "nested": {
                              "ModifierSequencingSettings": {
                                "fields": {
                                  "featureEnabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.releasemanager?.nested?.ModifierSequencingSettings) {
  $root.addJSON(jsonData);
}

/**
 * RST-41629: This is a release manager feature for modifier sequencing
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE ModifierSequencingSettings @ squareup/devicesettings/profiles/v2/model/settings/releasemanager/modifier_sequencing_settings.proto at 19:1
 */
export const ModifierSequencingSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.releasemanager.ModifierSequencingSettings');
fixType(ModifierSequencingSettings);
Builder.createAndAttachToType(ModifierSequencingSettings);